import { Reducer } from "redux";
import { AnyAction } from "redux";

import {
    SET_FEED_OPTIONS_DATA,
    FEED_OPTIONS_DATA_LOADING,
    FEED_OPTIONS_DATA_ERROR,
} from "./constants";
import { SET_ALL_FEEDS_DATA, SET_ALL_FEEDS_DATA_LOADING, SET_ALL_FEEDS_DATA_ERROR, SET_IS_NEED_UPDATE_DATA } from "./constants";
import type { IAllFeedOptionsData } from "api/services/feed/types";
import { IFormFeedData } from "./types";

export interface IFeedReducerFeed {
    data: {
        data: IFormFeedData[] | null,
        isLoading: boolean,
        error: string | null
    }
    options: {
        data: IAllFeedOptionsData | null,
        isLoading: boolean,
        isNeedUpdateData: boolean,
        error: string | null
    },

}

interface IFeedReducer {
    feed: IFeedReducerFeed
}

const initialState: IFeedReducer = {
    feed: {
        data: {
            data: null,
            isLoading: false,
            error: null
        },
        options: {
            data: null,
            isLoading: false,
            isNeedUpdateData: false,
            error: null
        },
    }
}

const feeds: Reducer<IFeedReducer, AnyAction> = (state = initialState, action): IFeedReducer => {
    switch(action.type) {

        case SET_ALL_FEEDS_DATA: {
            return {
                ...state,
                feed: {
                    ...state.feed,
                    data: {
                        ...state.feed.data,
                        data: action.payload
                    }
                }
            }
        }

        case SET_ALL_FEEDS_DATA_LOADING: {
            return {
                ...state,
                feed: {
                    ...state.feed,
                    data: {
                        ...state.feed.data,
                        isLoading: action.payload
                    }
                }
            }
        }

        case SET_ALL_FEEDS_DATA_ERROR: {
            return {
                ...state,
                feed: {
                    ...state.feed,
                    data: {
                        ...state.feed.data,
                        error: action.payload
                    }
                }
            }
        }

        case SET_FEED_OPTIONS_DATA: {
            return {
                ...state,
                feed: {
                    ...state.feed,
                    options: {
                        ...state.feed.options,
                        data: action.payload
                    }
                }
            }
        }

        case FEED_OPTIONS_DATA_LOADING: {
            return {
                ...state,
                feed: {
                    ...state.feed,
                    options: {
                        ...state.feed.options,
                        isLoading: action.payload
                    }
                }
            }
        }


        case SET_IS_NEED_UPDATE_DATA: {
            return {
                ...state,
                feed: {
                    ...state.feed,
                    options: {
                        ...state.feed.options,
                        isNeedUpdateData: action.payload
                    }
                }
            }
        }

        case FEED_OPTIONS_DATA_ERROR: {
            return {
                ...state,
                feed: {
                    ...state.feed,
                    options: {
                        ...state.feed.options,
                        error: action.payload
                    }
                }
            }
        }

        default: return state;

    }
}

export default feeds;